import {productQuantitySwitcher,productTabMenu,productThumbnails} from './product.js'
import {initSubscribe} from './subscribe';
import {bundleScript} from './bundle.js'

if (document.readyState !== 'loading') {
  productQuantitySwitcher()
  productTabMenu();
  productThumbnails();
  initSubscribe();
  bundleScript();
} else{
  document.addEventListener(
    'DOMContentLoaded',
    initSubscribe
  );
  document.addEventListener(
    'DOMContentLoaded',
    bundleScript
  );
  document.addEventListener(
    'DOMContentLoaded',
    productQuantitySwitcher,
  );
  document.addEventListener(
    'DOMContentLoaded',
    productTabMenu,
  );
  document.addEventListener(
    'DOMContentLoaded',
    productThumbnails,
  );
}
